export default __webpack_public_path__ + "static/media/sphere-2x.30a3733f.svg";